import { render, staticRenderFns } from "./SharedGenericLatestDetails.vue?vue&type=template&id=716282a7"
import script from "./SharedGenericLatestDetails.vue?vue&type=script&lang=js"
export * from "./SharedGenericLatestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports